import { Screen, useNavigate } from "flemo";
import { ClipboardListIcon } from "lucide-react";
import { useEffect } from "react";

import { AuthGuard } from "@/components/AuthGuard";
import { EmptyState } from "@/components/EmptyState";
import { Button } from "@/components/ui/button";
import { TestPhase } from "@/lib/constant";

import { QuizSkeleton } from "./_components/QuizSkeleton";
import { QuizView } from "./_components/quizView";
import { RecallView } from "./_components/RecallView";
import { ReportView } from "./_components/reportView";
import { ScoreModal } from "./_components/ScoreModal";
import { QuizContext } from "./_hooks/QuizContext";
import { useQuiz } from "./_hooks/useQuiz";

export function TestPage() {
  const { replace } = useNavigate();
  const quiz = useQuiz();
  const {
    isLoading,
    isError,
    phase,
    isScoreModalOpen,
    score,
    isPassed,
    closeScoreModal,
    questions,
    recallCount,
    startRecall,
    skipRecall,
    exitToList,
  } = quiz;

  // 존재하지 않는 시험 접근 시 홈으로 리다이렉트
  useEffect(() => {
    if (isError) {
      replace("/tests", {}, { transitionName: "none" });
    }
  }, [isError, replace]);

  return (
    <QuizContext.Provider value={quiz}>
      <AuthGuard>
        <Screen>
          <main className="h-dvh overflow-hidden bg-primary-background pt-safe sm:bg-tertiary sm:flex sm:items-center sm:justify-center">
            {isLoading && <QuizSkeleton />}
            {!isLoading && !isError && questions.length === 0 && (
              <div className="flex flex-col items-center justify-center min-h-[50vh] gap-6 px-5">
                <EmptyState
                  icon={ClipboardListIcon}
                  title="이 테스트에 문항이 없어요"
                  description="목록으로 돌아가서 다시 시도해 주세요."
                />
                <Button type="button" variant="default" className="rounded-md px-8" onClick={exitToList}>
                  테스트 목록으로
                </Button>
              </div>
            )}
            {!isLoading && !isError && questions.length > 0 && phase.type === TestPhase.TEST && <QuizView />}
            {!isLoading && !isError && questions.length > 0 && phase.type === "recall" && <RecallView />}
            {!isLoading && !isError && questions.length > 0 && phase.type === TestPhase.REPORT && <ReportView />}
            <ScoreModal
              open={isScoreModalOpen}
              score={score}
              isPassed={isPassed}
              recallCount={recallCount}
              onConfirm={closeScoreModal}
              onStartRecall={startRecall}
              onSkipRecall={skipRecall}
            />
          </main>
        </Screen>
      </AuthGuard>
    </QuizContext.Provider>
  );
}
